<template>
  <AppLayout>
    <div class="transaction">
      <section id="transaction-products">
        <div class="container">
        
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <!--<button @click="$router.back()" class="btn btn-outline-secondary btn-sm me-3">
              <i class="fas fa-arrow-left"></i> Back to Tenders Again
            </button> -->

      <!-- Quotation Summary Modal -->
      <div v-if="showSummaryModal">
        <div class="modal-overlay" @click="showSummaryModal = false">
          <div class="modal-content" @click.stop style="max-width:1000px;">
            <div class="modal-header">
              <h5 class="fw-bold">Quotation Summary</h5>
              <button @click="showSummaryModal = false" class="close-btn"><i class="fas fa-times"></i></button>
            </div>
            <div class="modal-body">
              <div style="overflow:auto">
                <table class="info-table" style="width:100%;">
                  <thead>
                    <tr>
                      <th>Supplier</th>
                      <th v-for="itm in quotationSummary().items" :key="itm">{{ itm }}</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in quotationSummary().rows" :key="row.supplier">
                      <td>{{ row.supplier }}</td>
                      <td v-for="itm in quotationSummary().items" :key="itm">
                        <span :class="{ lowest: (quotationSummary().mins && quotationSummary().mins[itm] != null && row[itm] === quotationSummary().mins[itm]) }">
                          {{ row[itm] != null ? formatCurrency(row[itm], tender?.currency) : '-' }}
                        </span>
                      </td>
                      <td>{{ formatCurrency(row.total, tender?.currency) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer" style="padding:12px 24px; text-align:right; border-top:1px solid #eef2f6">
              <button @click="showSummaryModal = false" class="btn btn-outline">Close</button>
            </div>
          </div>
        </div>
      </div>
            <h6 style="margin-bottom: 0px; display: inline-block;" class="fw-bold text-primary">{{ tender?.title }} - Applications</h6>
          </div>
          <div>
            <button @click="showSummaryModal = true" class="btn btn-outline-primary btn-sm">Quotation Summary</button>
          </div>
        </div>

        <!-- Stats Cards Section -->
        <div class="warehouse-inventory-card-wrapper mb-4">
          <div class="warehouse-inventory-card">
            <p>Reference <br>Number</p>
            <strong>{{ tender?.referenceNumber || 'N/A' }}</strong>
          </div>
          <div class="warehouse-inventory-card">
            <p>Submission <br>Deadline</p>
            <strong class="red">{{ formatDate(tender?.submissionDeadline) }}</strong>
          </div>
          <div class="warehouse-inventory-card">
            <p>Tender <br>Status</p>
            <strong :class="tender?.status === 'PUBLISHED' ? 'orange' : 'red'">{{ tender?.status || 'N/A' }}</strong>
          </div>
          <div class="warehouse-inventory-card">
            <p>Total <br>Applications</p>
            <strong>{{ submissions.length || 0 }}</strong>
          </div>
          <div class="warehouse-inventory-card">
            <p>Under <br>Review</p>
            <strong class="orange">{{ submissions.filter(s => s.status === 'UNDER_REVIEW').length }}</strong>
          </div>
          <div class="warehouse-inventory-card">
            <p>Shortlisted <br>Applications</p>
            <strong class="orange">{{ submissions.filter(s => s.status === 'SHORTLISTED').length }}</strong>
          </div>
        </div>
  
    <!-- Submissions List -->
    <div class="submissions-section">
      <div v-if="loading" class="loading">
        <i class="fas fa-spinner fa-spin"></i>
        <p>Loading submissions...</p>
      </div>

      <div v-else-if="submissions.length === 0" class="empty-state">
        <i class="fas fa-inbox"></i>
        <h3>No Applications Yet</h3>
        <p>No applications have been submitted for this tender.</p>
      </div>

      <div v-else class="table-responsive">
        <table class="table table-hover">
          <thead style="background-color: #f8f9fa; border-bottom: 2px solid #dee2e6;">
            <tr>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">Company</th>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">Contact</th>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">Email</th>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">Submitted</th>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">Value</th>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">Quoted Total</th>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">PO</th>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">Procurement Category</th>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">Status</th>
              <th style="padding: 15px 12px; font-weight: 600; font-size: 12px; color: #495057; text-align: left;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="submission in submissions" :key="submission.id">
              <td>
                <div>
                  <p class="mb-0">{{ submission.companyName }}</p>
                  <small class="text-muted">{{ submission.companyRegistration || '' }}</small>
                  <div v-if="submission.status === 'AWARDED' && submission.linkedPurchase">
                    <small class="text-muted">{{ (submission.linkedPurchase.Supplier && submission.linkedPurchase.Supplier.name) || submission.companyName }} - {{ submission.linkedPurchase.purchaseNo }}</small>
                  </div>
                </div>
              </td>
              <td>
                <div>
                  <span v-if="submission.contactPerson">{{ submission.contactPerson }}</span>
                  <span v-else>-</span>
                </div>
              </td>
              <td>
                <div>
                  <span v-if="submission.contactEmail">{{ submission.contactEmail }}</span>
                  <span v-else>-</span>
                </div>
              </td>
              <td>{{ formatDate(submission.submittedAt) }}</td>
              <td>{{ submission.proposedValue ? formatCurrency(submission.proposedValue, submission.proposedCurrency) : 'N/A' }}</td>
              <td>{{ (submission.quotedTotal != null) ? formatCurrency(submission.quotedTotal, submission.quotedCurrency || submission.proposedCurrency || tender?.currency) : 'N/A' }}</td>
              <td>
                <div>
                  <span v-if="submission.linkedPurchase">
                    <a :href="`/purchases/pdf/${submission.linkedPurchase.id}`">{{ submission.linkedPurchase.purchaseNo }}</a>
                  </span>
                  <span v-else>-</span>
                </div>
              </td>
              <td>{{ submission.tenderCategoryName || tender?.category || 'N/A' }}</td>
              <td>
                <span :class="`badge badge-${getStatusClass(submission.status)}`">{{ submission.status }}</span>
              </td>
              <td>
                <button @click.stop="viewSubmission(submission.id)" class="btn btn-sm" title="View">
                  <i class="fas fa-eye"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Submission Detail Modal -->
    <div v-if="selectedSubmission" class="modal-overlay" @click="selectedSubmission = null">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h5 class="fw-bold">{{ selectedSubmission.companyName }}</h5>
          <div style="display:flex;gap:8px;align-items:center">
            <button v-if="selectedSubmission.status !== 'AWARDED'" @click="awardSubmission" class="btn btn-sm btn-success" title="Award Tender">
              <i class="fas fa-award"></i>&nbsp;Award Tender
            </button>
            <button v-if="!selectedSubmission.supplierId" @click="onboardSupplier" :disabled="onboardInProgress" class="btn btn-sm btn-outline" title="Onboard Supplier">
              <i v-if="!onboardInProgress" class="fas fa-user-plus"></i>
              <i v-else class="fas fa-spinner fa-spin" aria-hidden="true"></i>
              &nbsp;<span v-if="!onboardInProgress">Onboard Supplier</span><span v-else>Onboarding...</span>
            </button>
            <button @click="selectedSubmission = null" class="close-btn">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        
        <div class="modal-body">
          <div class="submission-details">
            <section class="detail-section">
              <h6 class="fw-bold">Company Information</h6>
              <div class="detail-grid">
                <div class="detail-item full-width">
                  <table class="info-table">
                    <thead>
                      <tr>
                        <th>Company</th>
                        <th>Email</th>
                        <th>Phone</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ selectedSubmission.companyName }}</td>
                        <td>{{ selectedSubmission.companyEmail }}</td>
                        <td>{{ selectedSubmission.companyPhone || '-' }}</td>
                      </tr>
                    </tbody>
                  </table>


                  <table class="info-table" style="margin-top:12px">
                    <thead>
                      <tr>
                        <th>Registration / ID Number:</th>
                        <th>Address:</th>
                        <th>Website:</th>
                        <th>Nature of Business:</th>
                        <th>Procurement Category:</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td >{{ selectedSubmission?.companyRegistration }}</td>
                        <td>{{ selectedSubmission?.companyAddress }}</td>
                        <td><a :href="selectedSubmission?.companyWebsite?.startsWith('http') ? selectedSubmission.companyWebsite : 'https://' + selectedSubmission.companyWebsite" target="_blank" rel="noopener">{{ selectedSubmission?.companyWebsite }}</a></td>
                        <td>{{ selectedSubmission?.companyExperience }}</td>
                        <td>{{ tender?.category || (selectedSubmission?.tenderCategoryName || 'N/A') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
            
            <section class="detail-section" v-if="selectedSubmission.technicalProposal">
              <h6 class="fw-bold">Technical Proposal</h6>
              <p class="detail-text">{{ selectedSubmission.technicalProposal }}</p>
            </section>
            
            <section class="detail-section" v-if="selectedSubmission.financialProposal">
              <h6 class="fw-bold">Financial Proposal</h6>
              <p class="detail-text">{{ selectedSubmission.financialProposal }}</p>
            </section>

             <section class="detail-section" v-if="submissionQuotation && submissionQuotation.items && submissionQuotation.items.length">
              <h6 class="fw-bold">Submitted Quotation</h6>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Unit</th>
                      <th>Qty</th>
                      <th>Unit Price</th>
                      <th>Line Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(it, i) in submissionQuotation.items" :key="i">
                      <td>{{ it.name || it.item || ('Item ' + (i+1)) }}</td>
                      <td>{{ it.unit || '-' }}</td>
                      <td>{{ it.quantity || it.qty || 1 }}</td>
                      <td>{{ formatCurrency(it.unitPrice || 0, selectedSubmission.proposedCurrency || tender?.currency || 'USD') }}</td>
                      <td>{{ formatCurrency((Number(it.unitPrice || 0) * Number(it.quantity || it.qty || 1)), selectedSubmission.proposedCurrency || tender?.currency || 'USD') }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4" style="text-align:right; font-weight:600">Total</td>
                      <td style="font-weight:700">{{ formatCurrency(submissionQuotation.total || submissionQuotation.items.reduce((s, it) => s + (Number(it.unitPrice||0) * Number(it.quantity||it.qty||1)), 0), selectedSubmission.proposedCurrency || tender?.currency || 'USD') }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </section>

            <section class="detail-section" v-if="selectedSubmission.submissionDocuments && selectedSubmission.submissionDocuments.length">
              <h6 class="fw-bold">Attachments</h6>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width:35%">Document Type</th>
                      <th>Attachment</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(doc, idx) in selectedSubmission.submissionDocuments" :key="idx">
                      <td>
                        {{ getDocTypeName(doc) }}
                      </td>
                      <td>
                        <a :href="`${DOWNLOAD_BASE}/files/${(doc.path || '').split('/')[0]}/${(doc.path || '').split('/').slice(1).join('/')}`" target="_blank" rel="noopener">
                          {{ doc.originalname || doc.path }}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
                      <div style="margin-top:12px">
                        <h6 class="fw-bold">Onboarding Results</h6>
                        <div v-if="onboardInProgress" class="onboard-loader">
                          <i class="fas fa-spinner fa-spin" style="font-size:20px"></i>
                          <span style="margin-left:8px">Onboarding supplier — please wait...</span>
                        </div>
                        <ul v-else-if="onboardResults && onboardResults.length" style="font-size:13px; color:#374151;">
                          <li v-for="(r, i) in onboardResults" :key="i">
                            <span v-if="r.ok" style="color:green">Uploaded document id: {{ r.id }}</span>
                            <span v-else style="color:#b91c1c">Failed: {{ r.reason || 'unknown' }}</span>
                          </li>
                        </ul>
                      </div>
            </section>

           
            
            <section class="detail-section" v-if="selectedSubmission.companyExperience">
              <h5 class="fw-bold">Company Experience</h5>
              <p class="detail-text">{{ selectedSubmission.companyExperience }}</p>
            </section>
            
            <!-- Status Update Section -->
            <section class="detail-section">
              <h6 class="fw-bold">Evaluation</h6>
              <div class="evaluation-form">
                <div class="form-group">
                  <label>Status:</label>
                  <select v-model="evaluationForm.status">
                    <option value="SUBMITTED">Submitted</option>
                    <option value="UNDER_REVIEW">Under Review</option>
                    <option value="SHORTLISTED">Shortlisted</option>
                    <option value="REJECTED">Rejected</option>
                    <option value="AWARDED">Awarded</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Score (1-5):</label>
                  <input 
                    v-model.number="evaluationForm.score" 
                    type="number" 
                    min="1" 
                    max="5" 
                    step="0.1"
                  />
                </div>
                <div class="form-group">
                  <label>Evaluation Notes:</label>
                  <textarea 
                    v-model="evaluationForm.notes" 
                    rows="4" 
                    placeholder="Add evaluation notes..."
                  ></textarea>
                </div>
                <div class="form-actions">
                  <button @click="saveEvaluation" class="btn btn-primary">
                    Save Evaluation
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
    
    </div> <!-- Close container -->
    </section>
  </div>
</AppLayout>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppLayout from '../../components/AppLayout.vue'
import { tenderApi, API_BASE_URL } from '@/api/tender'
import { showToast } from '@/utils/toast'
import Swal from 'sweetalert2'

export default {
  name: 'SubmissionManagement',
   components: {
    AppLayout,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    
    const loading = ref(false)
    const tender = ref(null)
    const submissions = ref([])
    const selectedSubmission = ref(null)
    const submissionQuotation = ref(null)
    const supplierDocTypes = ref([])
    const onboardInProgress = ref(false)
    const onboardResults = ref([])
    
    const evaluationForm = reactive({
      status: '',
      score: '',
      notes: '',
    })
    
    const fetchTender = async () => {
      try {
        const response = await tenderApi.getTender(route.params.id)
        // backend may return the tender directly or wrapped in { data }
        tender.value = (response && response.data) ? response.data : response
      } catch (error) {
        console.error('Error fetching tender:', error)
        showToast('Error loading tender details', 'error')
      }
    }

    const fetchSupplierDocumentTypes = async () => {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch(`${API_BASE_URL}/supplier-document-type`, { headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' } })
        if (!res.ok) return
        const data = await res.json()
        supplierDocTypes.value = Array.isArray(data) ? data : (data.data || [])
      } catch (err) {
        console.warn('Failed to load supplier document types', err)
      }
    }

    // Quotation summary modal state and computed matrix
    const showSummaryModal = ref(false)
    const quotationSummary = () => {
      // gather unique item keys from submissions' quotations or tender items
      const itemNames = new Set()
      // try submissions first
      submissions.value.forEach((s) => {
        try {
          const q = s.quotation
          const parsed = q ? (typeof q === 'string' ? JSON.parse(q) : q) : null
          if (parsed && Array.isArray(parsed.items)) {
            parsed.items.forEach((it) => itemNames.add(it.name || it.code || String(it.id || '')))
          }
        } catch (e) {
          console.debug('Could not parse submission quotation', e)
        }
      })
      // fallback to tender items
      if (itemNames.size === 0 && tender.value) {
        const rawItems = tender.value?.items || tender.value?.tenderItems || tender.value?.products || []
        rawItems.forEach((it) => {
          const name = (it.product && it.product.name) || it.description || it.name || ''
          if (name) itemNames.add(name)
        })
      }
      const items = Array.from(itemNames)

      // build rows per submission
      const rows = submissions.value.map((s) => {
        const row = { supplier: s.companyName || s.companyEmail || `#${s.id}` }
        let rowTotal = 0
        try {
          const q = s.quotation
          const parsed = q ? (typeof q === 'string' ? JSON.parse(q) : q) : null
          const itemMap = {}
          if (parsed && Array.isArray(parsed.items)) {
            parsed.items.forEach((it) => {
              const key = it.name || it.code || String(it.id || '')
              itemMap[key] = Number(it.unitPrice || it.price || it.total || 0)
            })
          }
          items.forEach((iname) => {
            const v = itemMap[iname]
            row[iname] = (v != null && !Number.isNaN(v)) ? v : null
            if (row[iname]) rowTotal += Number(row[iname])
          })
        } catch (e) {
          items.forEach((iname) => { row[iname] = null })
        }
        row.total = rowTotal
        return row
      })

      // compute per-item minima
      const mins = {}
      items.forEach((iname) => {
        const vals = rows.map((r) => r[iname]).filter((v) => v != null && !Number.isNaN(Number(v))).map(Number)
        mins[iname] = vals.length > 0 ? Math.min(...vals) : null
      })

      return { items, rows, mins }
    }
    
    const fetchSubmissions = async () => {
      loading.value = true
      try {
        const response = await tenderApi.getTenderSubmissions(route.params.id)
        // handle response that may be either { data: [...] } or the array directly
        let list = []
        if (response && response.data && Array.isArray(response.data)) list = response.data
        else if (Array.isArray(response)) list = response
        else list = (response && response.data && Array.isArray(response.data.data)) ? response.data.data : []

        // Compute quotedTotal and quotedCurrency for display
        submissions.value = list.map((s) => {
          let quotedTotal = null
          let quotedCurrency = s.proposedCurrency || tender.value?.currency || 'USD'
          try {
            const q = s.quotation
            const parsed = q ? (typeof q === 'string' ? JSON.parse(q) : q) : null
            if (parsed && (parsed.total || parsed.total === 0)) quotedTotal = Number(parsed.total)
          } catch (e) {
            console.debug('Could not parse quotation for submission list', e)
          }
          // fallback to proposedValue if no quotation total
          if (quotedTotal == null && (s.proposedValue || s.proposedValue === 0)) quotedTotal = s.proposedValue
          return { ...s, quotedTotal, quotedCurrency }
        })
      } catch (error) {
        console.error('Error fetching submissions:', error)
        showToast('Error loading submissions', 'error')
      } finally {
        loading.value = false
      }
    }
    
    const viewSubmission = async (id) => {
      try {
        const response = await tenderApi.getSubmission(id)
        // normalize response shape: API may return the submission directly or wrapped in { data }
        const payload = (response && response.data) ? response.data : response
        selectedSubmission.value = payload || null

        // parse quotation JSON if present
        try {
          const q = payload?.quotation
          if (q) {
            submissionQuotation.value = typeof q === 'string' ? JSON.parse(q) : q
          } else {
            submissionQuotation.value = null
          }
        } catch (e) {
          console.debug('Could not parse submission quotation', e)
          submissionQuotation.value = null
        }

        // Populate evaluation form (guard if payload missing)
        evaluationForm.status = payload?.status || ''
        evaluationForm.score = payload?.evaluationScore || ''
        evaluationForm.notes = payload?.evaluationNotes || ''
      } catch (error) {
        console.error('Error fetching submission:', error)
        showToast('Error loading submission details', 'error')
      }
    }

      const getDocTypeName = (doc) => {
        if (!doc) return 'Unspecified'
        const byRel = doc.supplierDocumentType && doc.supplierDocumentType.name
        if (byRel) return byRel
        const id = doc.supplierDocumentTypeId || null
        if (id) {
          const found = supplierDocTypes.value.find(t => t.id === Number(id))
          if (found) return found.name
        }
        return 'Unspecified'
      }

    const onboardSupplier = async () => {
      if (!selectedSubmission.value) return
      const ok = await Swal.fire({
        title: 'Onboard Supplier',
        text: `Create supplier for ${selectedSubmission.value.companyName || 'this company'} and attach submitted documents?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, onboard',
      })
      if (!ok.isConfirmed) return

      const token = JSON.parse(localStorage.getItem('access_token'))
      onboardInProgress.value = true
      onboardResults.value = []
      try {
        const supplierPayload = {
          name: selectedSubmission.value.companyName || undefined,
          // prefer an explicit business field, fall back to companyExperience
          business: selectedSubmission.value.business || selectedSubmission.value.companyExperience || undefined,
          // also include natureOfBusiness for clarity (backend will map it)
          natureOfBusiness: selectedSubmission.value.companyExperience || selectedSubmission.value.business || undefined,
          address: selectedSubmission.value.companyAddress || undefined,
          contact: selectedSubmission.value.contactPerson || undefined,
          phone: selectedSubmission.value.companyPhone || undefined,
          email: selectedSubmission.value.companyEmail || undefined,
          idNumber: selectedSubmission.value.companyRegistration || undefined,
          prequalified: true,
        }

        const res = await fetch(`${API_BASE_URL}/tender/submission/${selectedSubmission.value.id}/onboard`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' },
          body: JSON.stringify({ supplier: supplierPayload }),
        })
        const json = await res.json()
        if (!res.ok || !json || !json.status) {
          throw new Error(json?.message || 'Onboard failed')
        }
        onboardResults.value = json.results || []
        await Swal.fire('Onboarded', `Supplier created (id: ${json.supplierId}) — attached ${json.attached} documents`, 'success')
        // refresh submission details to show supplier link
        selectedSubmission.value = null
        fetchSubmissions()
      } catch (err) {
        console.error('Error onboarding supplier', err)
        await Swal.fire('Error', err.message || 'Failed to onboard supplier', 'error')
      } finally {
        onboardInProgress.value = false
      }
    }

    const awardSubmission = async () => {
      if (!selectedSubmission.value) return

      // Prevent awarding to suppliers that are not onboarded
      const supplierId = selectedSubmission.value.supplierId || (selectedSubmission.value.Supplier && selectedSubmission.value.Supplier.id) || null
      if (!supplierId) {
        const go = await Swal.fire({
          icon: 'warning',
          title: 'Cannot award',
          text: 'This supplier has not been onboarded. Onboard the supplier before awarding.',
          showCancelButton: true,
          confirmButtonText: 'Onboard now',
          cancelButtonText: 'Cancel',
        })
        if (go.isConfirmed) {
          await onboardSupplier()
        }
        return
      }

      const result = await Swal.fire({
        title: 'Confirm Award',
        text: `Award this tender to ${selectedSubmission.value.companyName || 'this supplier'}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, award',
        cancelButtonText: 'Cancel',
      })
      if (!result.isConfirmed) return
      try {
        await tenderApi.updateSubmissionStatus(selectedSubmission.value.id, { status: 'AWARDED' })
        await Swal.fire({ icon: 'success', title: 'Awarded!', text: 'Tender awarded successfully', timer: 1400, showConfirmButton: false })
        // Redirect to Add Purchase page with tender and supplier preselected
        const tid = selectedSubmission.value.tenderId || (selectedSubmission.value.tender && selectedSubmission.value.tender.id) || route.params.id
        router.push({ path: '/purchases/add', query: { tenderId: String(tid || ''), tenderSubmissionId: String(selectedSubmission.value.id), supplierId: String(supplierId) } })
      } catch (err) {
        console.error('Error awarding submission:', err)
        await Swal.fire('Error', 'Error awarding tender', 'error')
      }
    }
    
    const updateStatus = async (submissionId, status) => {
      try {
        await tenderApi.updateSubmissionStatus(submissionId, { status })
        showToast(`Application ${status.toLowerCase().replace('_', ' ')}`, 'success')
        fetchSubmissions() // Refresh the list
      } catch (error) {
        console.error('Error updating status:', error)
        showToast('Error updating application status', 'error')
      }
    }
    
    const saveEvaluation = async () => {
      if (!selectedSubmission.value) return
      
      try {
        await tenderApi.updateSubmissionStatus(selectedSubmission.value.id, {
          status: evaluationForm.status,
          evaluationScore: evaluationForm.score,
          evaluationNotes: evaluationForm.notes,
        })
        
        showToast('Evaluation saved successfully', 'success')
        selectedSubmission.value = null
        fetchSubmissions() // Refresh the list
      } catch (error) {
        console.error('Error saving evaluation:', error)
        showToast('Error saving evaluation', 'error')
      }
    }
    
    const formatDate = (dateString) => {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    }
    
    const formatCurrency = (amount, currency) => {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount)
    }
    
    const formatStatus = (status) => {
      return status.replace('_', ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase())
    }

    const getStatusClass = (status) => {
      const statusMap = {
        'SUBMITTED': 'primary',
        'UNDER_REVIEW': 'info',
        'SHORTLISTED': 'success',
        'REJECTED': 'danger',
        'AWARDED': 'success'
      }
      return statusMap[status] || 'secondary'
    }

    const DOWNLOAD_BASE = API_BASE_URL
    
    onMounted(() => {
      fetchTender()
      fetchSubmissions()
      fetchSupplierDocumentTypes()
    })
    
    return {
      loading,
      tender,
      submissions,
      selectedSubmission,
      submissionQuotation,
      showSummaryModal,
      quotationSummary,
      evaluationForm,
      viewSubmission,
      awardSubmission,
      onboardSupplier,
      onboardInProgress,
      onboardResults,
      updateStatus,
      saveEvaluation,
      formatDate,
      formatCurrency,
      formatStatus,
      getStatusClass,
      DOWNLOAD_BASE,
      getDocTypeName,
    }
  },
}
</script>

<style scoped>
.submission-management {
  padding: 24px;
}

.header {
  margin-bottom: 24px;
}

.title-section h1 {
  font-size: 28px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 12px 0 8px 0;
}

.title-section p {
  color: #666;
  margin: 0;
}

.tender-info-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.tender-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
}

.meta-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.meta-item strong {
  font-size: 14px;
  color: #374151;
}

.meta-item span {
  font-size: 14px;
  color: #666;
}
/* Highlight lowest quotation values */
.info-table td.lowest,
.info-table span.lowest {
  color: #059669 !important; /* emerald-600 */
  font-weight: 700 !important;
}
.info-table span.lowest { display: inline-block; }

.status {
  padding: 4px 12px;
  border-radius: 14px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.status.submitted { background: #e0f2fe; color: #0288d1; }
.status.under_review { background: #fff3e0; color: #f57c00; }
.status.shortlisted { background: #e8f5e8; color: #2e7d32; }
.status.rejected { background: #ffebee; color: #d32f2f; }
.status.awarded { background: #f3e5f5; color: #7b1fa2; }
.status.draft { background: #fef3c7; color: #92400e; }
.status.published { background: #d1fae5; color: #065f46; }
.status.closed { background: #f3f4f6; color: #374151; }

.loading {
  text-align: center;
  padding: 48px;
  color: #666;
}

.loading i {
  font-size: 24px;
  margin-bottom: 14px;
}

.empty-state {
  text-align: center;
  padding: 48px;
  color: #666;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 14px;
  color: #d1d5db;
}

.submissions-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.submission-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #e5e7eb;
}

.submission-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-color: #3b82f6;
}

.submission-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 14px;
}

.company-info h3 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #1a1a1a;
}

.company-info p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.proposal-summary h4 {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #374151;
}

.proposal-summary p {
  color: #666;
  margin: 0 0 14px 0;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.meta-grid {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.submission-meta .meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
}

.submission-meta .meta-item i {
  color: #3b82f6;
  width: 14px;
}

.submission-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 14px;
}

.btn {
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-outline {
  border: 1px solid #e5e7eb;
  color: #374151;
  background: white;
}

.btn-outline:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.btn-success {
  background: #10b981;
  color: white;
}

.btn-success:hover {
  background: #059669;
}

.btn-danger {
  background: #ef4444;
  color: white;
}

.btn-danger:hover {
  background: #dc2626;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  max-width: 1200px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #1a1a1a;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: #f3f4f6;
  color: #1a1a1a;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.onboard-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}

.onboard-loader {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #374151;
}

.detail-section {
  margin-bottom: 24px;
}

.detail-section h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 14px 0;
  color: #1a1a1a;
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;
}
.info-table th, .info-table td {
  text-align: left;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
}
.info-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #374151;
}

.detail-item.full-width {
  grid-column: 1 / -1;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-item strong {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

.detail-item span {
  font-size: 14px;
  color: #666;
}

.detail-text {
  color: #374151;
  line-height: 1.7;
  white-space: pre-wrap;
}

.evaluation-form {
  background: #f8fafc;
  border-radius: 8px;
  padding: 14px;
}

.form-group {
  margin-bottom: 14px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #374151;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-actions {
  text-align: right;
}

@media (max-width: 768px) {
  .tender-meta {
    grid-template-columns: 1fr;
  }
  
  .submission-header {
    flex-direction: column;
    gap: 12px;
  }
  
  .meta-grid {
    flex-direction: column;
    gap: 8px;
  }
  
  .detail-grid {
    grid-template-columns: 1fr;
  }
}
</style>